export default "__VITE_ASSET__PyP$5_tQ__"